const InputFields = [
  {
    name: "image",
    type: "image",
    label: "Category Image",
  },
  {
    name: "name",
    type: "text",
    label: "Category Name",
  },
];

export default InputFields;